"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.Services = void 0;
exports.handleGenericError = handleGenericError;
const tslib_1 = require("tslib");
const notification_service_1 = require("../components/notification.toast/notification.service");
const index_1 = require("../i18n/index");
const license_service_1 = require("../services/license.service");
const analytics_service_1 = require("./analytics.service");
const collection_service_1 = require("./collection.service");
const config_service_1 = require("./config.service");
const dashboard_service_1 = require("./dashboard.service");
const date_time_service_1 = require("./date.time.service");
const department_service_1 = require("./department.service");
const download_service_1 = require("./download.service");
const draw_state_service_1 = require("./draw.state.service");
const export_service_1 = require("./export.service");
const focus_away_service_1 = require("./focus.away.service");
const form_service_1 = require("./form.service");
const geocoder_service_1 = require("./geocoder.service");
const ike_rest_service_1 = require("./ike.rest.service");
const input_service_1 = require("./input/input.service");
const log_service_1 = require("./log.service");
const map_service_1 = require("./map.service");
const measurement_service_1 = require("./measurement.service");
const multi_list_search_service_1 = require("./multi.list.search.service");
const observable_storage_1 = require("./observable.storage");
const render_service_1 = require("./render.service");
const route_service_1 = require("./route.service");
const search_org_service_1 = require("./search.org.service");
const search_service_1 = require("./search.service");
const sso_service_1 = require("./sso.service");
const streetview_service_1 = require("./streetview.service");
const subform_link_service_1 = require("./subform.link/subform.link.service");
const tag_service_1 = require("./tag.service");
const token_service_1 = require("./token.service");
const user_profile_service_1 = require("./user.profile.service");
const user_service_1 = require("./user.service");
const user_settings_service_1 = require("./user.settings.service");
const window_service_1 = require("./window.service");
function handleGenericError(e) {
    notification_service_1.NotificationService.error({
        key: index_1.T.ERROR_GENERAL,
    });
    return null;
}
class ServiceRegistry {
    constructor(Analytics = new analytics_service_1.AnalyticsService(), Collection = new collection_service_1.CollectionService(), Config = new config_service_1.ConfigService(), SSO = new sso_service_1.SSOService(), DateTime = new date_time_service_1.DateTimeService(), Department = new department_service_1.DepartmentService(log_service_1.Logger), Download = new download_service_1.DownloadService(), DrawState = new draw_state_service_1.DrawStateService(log_service_1.Logger), Export = new export_service_1.ExportService(), FocusAway = new focus_away_service_1.FocusAwayService(), Form = new form_service_1.FormService(), Geocoder = new geocoder_service_1.GeocoderService(), Input = new input_service_1.InputService(), LocalStorage = observable_storage_1.LocalStorage, Log = new log_service_1.LogService(), Map = new map_service_1.MapService(), Measurement = new measurement_service_1.MeasurementService(), Render = new render_service_1.RenderService(), Rest = new ike_rest_service_1.IkeRestService(), Route = new route_service_1.RouteService(), SearchOrg = new search_org_service_1.SearchOrgService(), Dashboard = new dashboard_service_1.DashboardService(), MultiListSearch = new multi_list_search_service_1.MultiListSearchService(), Search = new search_service_1.SearchService(), Streetview = new streetview_service_1.StreetviewService(), SubFormLink = new subform_link_service_1.SubFormLinkService(), Tag = new tag_service_1.TagService(), Token = new token_service_1.TokenService(), User = new user_service_1.SSOUserService(), UserProfile = new user_profile_service_1.UserProfileService(log_service_1.Logger), UserSettings = new user_settings_service_1.UserSettingsService(), Window = new window_service_1.WindowService(), License = new license_service_1.LicenseService()) {
        this.Analytics = Analytics;
        this.Collection = Collection;
        this.Config = Config;
        this.SSO = SSO;
        this.DateTime = DateTime;
        this.Department = Department;
        this.Download = Download;
        this.DrawState = DrawState;
        this.Export = Export;
        this.FocusAway = FocusAway;
        this.Form = Form;
        this.Geocoder = Geocoder;
        this.Input = Input;
        this.LocalStorage = LocalStorage;
        this.Log = Log;
        this.Map = Map;
        this.Measurement = Measurement;
        this.Render = Render;
        this.Rest = Rest;
        this.Route = Route;
        this.SearchOrg = SearchOrg;
        this.Dashboard = Dashboard;
        this.MultiListSearch = MultiListSearch;
        this.Search = Search;
        this.Streetview = Streetview;
        this.SubFormLink = SubFormLink;
        this.Tag = Tag;
        this.Token = Token;
        this.User = User;
        this.UserProfile = UserProfile;
        this.UserSettings = UserSettings;
        this.Window = Window;
        this.License = License;
    }
    bindServices() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a, e_1, _b, _c;
            const allServices = Object.values(this).sort((a, b) => a.__priority - b.__priority);
            try {
                for (var _d = true, allServices_1 = tslib_1.__asyncValues(allServices), allServices_1_1; allServices_1_1 = yield allServices_1.next(), _a = allServices_1_1.done, !_a; _d = true) {
                    _c = allServices_1_1.value;
                    _d = false;
                    const service = _c;
                    if (typeof service.init === 'function') {
                        try {
                            const initter = service.init();
                            if (initter && typeof initter.then === 'function') {
                                yield initter;
                            }
                        }
                        catch (error) {
                            throw error;
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_d && !_a && (_b = allServices_1.return)) yield _b.call(allServices_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    }
}
exports.Services = new ServiceRegistry();
exports.Logger = exports.Services.Log.Logger;
//# sourceMappingURL=index.js.map